import React, { Component } from 'react';
import { connect } from 'react-redux';
import {createSelector} from 'reselect';
import { Main } from '../../layout';
import { Container, Row, Accordion, Button } from 'react-bootstrap';
import { DocumentTitle, history } from '../../../helpers';
import { alertSelectors } from '../../../common/redux/selectors';
import { Skeleton } from '@material-ui/lab';
import { defaultService, globalService as gs } from '../../../common/services';

var rules2 = [
    {
        "tournament_id": 31,
        "rule_id": 11,
        "rule": {
            "id": 1,
            "name": "Basic 1",
            "content": "Whatever I can so far think of is this",
            "status": 1,
            "created_at": 1,
            "updated_at": 1
        }
    },
    {
        "tournament_id": 31,
        "rule_id": 12,
        "rule": {
            "id": 2,
            "name": "Basic 2",
            "content": "Basic 2Basic 2Basic 2",
            "status": 1,
            "created_at": 1595575607,
            "updated_at": 1595575607
        }
    }
]

class Faqs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search: '',
            faqs: [],
            faqs2: [],
            pagination: null,
            activeKey: 0,
            activeKey2: 0,
            loading: false
        }
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);
        this.setState({search: query.get('q')}, () => {
            this.loadFaqs();
            this.loadFaqs2();
        });
    }

    loadFaqs = () => {
        const { dispatch } = this.props;
        this.setState({loading: true});
        defaultService.item({ moduleId: 'faq', category_id: 15, q: this.state.search, 'per-page': 30 }).then(data=> {
            this.setState({ loading: false });
            if(data.code) {
                const faqs = data.items;
                this.setState({ faqs });
            } else {
                dispatch(alertSelectors.error('Action not found'));
            }
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({ loading: false });
        });
    }

    loadFaqs2 = () => {
        const { dispatch } = this.props;
        this.setState({loading: true});
        defaultService.item({ moduleId: 'faq', category_id: 16, q: this.state.search, 'per-page': 30 }).then(data=> {
            this.setState({ loading: false });
            if(data.code) {
                const faqs2 = data.items;
                this.setState({ faqs2 });
            } else {
                dispatch(alertSelectors.error('Action not found'));
            }
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({ loading: false });
        });
    }

    search = () => {
        history.push(`/faqs?q=${this.state.search}`);
        this.loadFaqs();
        this.loadFaqs2();
    }


    render() {
        const { activeKey, activeKey2, faqs, faqs2, loading } = this.state;

        return (<Main>
            <DocumentTitle title={`Faqs`}/>
            <section className="faq my-5">
                <Container>
                    <div className="search-form">
                        <Row>
                            <div className="col-lg-4 col-md-12 col-12">
                                <h4 className="font-weight-bold text-center mb-0">Hello, How can we help?</h4>
                            </div>
                            <div className="col-lg-5 col-md-12 col-12">
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Type your Question" value={this.state.search} onChange={e => this.setState({search: e.target.value})} />
                                    <div className="input-group-append">
                                        <button className="px-3 bg-white btn-light btn" type="button" onClick={() => this.search()}><i className="fas fa-search text-primary"></i></button>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </div>                  
                    
                        <Row>
                            <div className="col-lg-12 col-md-12 col-12">
                                <h1 className="text-center font-weight-bold text-info py-5">FAQ</h1>
                            </div>    
                            <div className="col-lg-6 col-md-6 col-12">            
                                <h3 className="">Parent</h3>
                                <Accordion className="panel-group">
                                    {loading ? <>
                                        {[1,2].map((item) =>
                                            <div className="w-100" key={`loading-${item}`}>
                                                <Skeleton variant="rect" width={'100%'} height={10} className="mb-2" />
                                                <Skeleton variant="rect" width={'100%'} height={10} className="mb-2" />
                                            </div>
                                        )}
                                    </> : <>
                                    {faqs && faqs.map((faq, index) =>
                                        <div className="panel panel-default" key={`rule${index}`}>
                                            <Accordion.Toggle className="panel-heading w-100 text-left p-0 border-0" as={Button} variant="link" eventKey={faq.id} onClick={() => {
                                                if (activeKey === faq.id) {
                                                    this.setState({activeKey: null});
                                                } else {
                                                    this.setState({activeKey: faq.id});
                                                }
                                            }}>
                                                <h4 className="panel-title">
                                                    <a role="button" rel="noopener noreferrer">
                                                        {activeKey === faq.id ? <i className="more-less fa fa-minus"></i> : <i className="more-less fa fa-plus"></i>}
                                                        {faq.title}  
                                                    </a>
                                                </h4>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse className="panel-collapse" eventKey={faq.id}>
                                                <div className="panel-body py-3">
                                                    <div dangerouslySetInnerHTML={{__html: faq.content}}></div>
                                                </div>
                                            </Accordion.Collapse>
                                        </div>
                                    )}
                                    </>}
                                    {(faqs && faqs.length === 0) && <div className="py-3">Faqs not found</div>}
                                </Accordion>
                                                                      
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">            
                                <h3 className="">Tutor</h3>
                                <Accordion className="panel-group">
                                    {loading ? <>
                                        {[1,2].map((item) =>
                                            <div className="w-100" key={`loading-${item}`}>
                                                <Skeleton variant="rect" width={'100%'} height={10} className="mb-2" />
                                                <Skeleton variant="rect" width={'100%'} height={10} className="mb-2" />
                                            </div>
                                        )}
                                    </> : <>
                                    {faqs2 && faqs2.map((faq, index) =>
                                        <div className="panel panel-default" key={`rule${index}`}>
                                            <Accordion.Toggle className="panel-heading w-100 text-left p-0 border-0" as={Button} variant="link" eventKey={faq.id} onClick={() => {
                                                if (activeKey2 === faq.id) {
                                                    this.setState({activeKey2: null});
                                                } else {
                                                    this.setState({activeKey2: faq.id});
                                                }
                                            }}>
                                                <h4 className="panel-title">
                                                    <a role="button" rel="noopener noreferrer">
                                                        {activeKey2 === faq.id ? <i className="more-less fa fa-minus"></i> : <i className="more-less fa fa-plus"></i>}
                                                        {faq.title}  
                                                    </a>
                                                </h4>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse className="panel-collapse" eventKey={faq.id}>
                                                <div className="panel-body py-3">
                                                    <div dangerouslySetInnerHTML={{__html: faq.content}}></div>
                                                </div>
                                            </Accordion.Collapse>
                                        </div>
                                    )}
                                    </>}
                                    {(faqs2 && faqs2.length === 0) && <div className="py-3">Faqs not found</div>}
                                </Accordion>
                                                                      
                            </div>
                        </Row>
                   
                </Container>
            </section>
            
        </Main>);
    }
}

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    authenticationSelector,

    (authentication) =>
        ({authentication})
);

export default connect(mapStateToProps)(Faqs);